import { render, staticRenderFns } from "./ShopsUsers.vue?vue&type=template&id=3dcf8b08&scoped=true&"
import script from "./ShopsUsers.vue?vue&type=script&lang=js&"
export * from "./ShopsUsers.vue?vue&type=script&lang=js&"
import style0 from "./ShopsUsers.vue?vue&type=style&index=0&id=3dcf8b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcf8b08",
  null
  
)

export default component.exports